export default function Logo() {
  return <h1>🌴 Travel-list 👜</h1>;
}
